/*
 * @Author: Teemo Ding
 * @Date: 2022-02-18 14:40:20
 * @LastEditTime: 2022-06-07 13:44:55
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/CommunicationTemplateDetail/GeneralInformation/index.tsx
 */
import { Input, Label, Select } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { templateCategoryList } from '../config';
import css from '../css.module.less';

const GeneralInformation = ({ form, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const handleSelectChange = () => {
    form.setFieldsValue({ forAll: true });
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('storeCommunicationSetting.common.generalInformation')}>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='category'
                rules={[
                  {
                    required: true,
                    //
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n(
                        'storeCommunicationSetting.detail.templateCategory',
                      ),
                    ),
                  },
                ]}
                label={
                  <Label
                    title={`${getI18n(
                      'storeCommunicationSetting.detail.templateCategory',
                    )}*`}
                  />
                }
                labelCol={{ span: 24 }}>
                <Select
                  onChange={handleSelectChange}
                  size='large'
                  optionsGroupList={templateCategoryList}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='name'
                rules={[
                  {
                    required: true,
                    // Template Name
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storeCommunicationSetting.detail.templateName'),
                    ),
                  },
                ]}
                label={
                  <Label
                    title={`${getI18n(
                      'storeCommunicationSetting.detail.templateName',
                    )}*`}
                    rightSubTitle={getI18n(
                      'storeCommunicationSetting.common.thisisforinternaluse',
                    )}
                    textLength={100}
                    nameKey='name'
                  />
                }
                labelCol={{ span: 24 }}>
                <Input maxLength={100} size='large' disabled={disableEdit} />
              </Form.Item>
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};

export default GeneralInformation;
